/**
 * AlreadyLoggedInBlock — logged-in non-SUB_DELEGATE (plan §7.2).
 * Only new accounts can become sub-delegates. Primary CTA signs out
 * (token is stashed by the page before logout so the flow resumes after).
 */

import { Link } from 'react-router-dom';
import { InviteSignupShell } from '@/shared/components/invite-signup';

export type AlreadyLoggedInBlockProps = {
  currentUserName: string;
  currentUserRoleLabel: string;
  ownerName: string;
  onSignOut: () => void;
};

export const AlreadyLoggedInBlock = ({
  currentUserName,
  currentUserRoleLabel,
  ownerName,
  onSignOut,
}: AlreadyLoggedInBlockProps) => (
  <InviteSignupShell>
    <h2 className="font-recoleta text-white md:w-full text-3xl md:text-4xl">
      You're already signed in
    </h2>

    <p className="font-termina text-white max-md:text-xl max-md:py-8 py-6">
      You are currently signed in as <strong>{currentUserName}</strong> (
      {currentUserRoleLabel}). Only new accounts can become sub-delegates — your
      existing role cannot be combined with a sub-delegate role. Please sign out
      to continue with the invitation from <strong>{ownerName}</strong>.
    </p>

    <div className="py-8 gap-4 flex flex-col">
      <button
        type="button"
        onClick={onSignOut}
        className="font-termina bg-[#E2A807] font-black rounded-3xl py-3 px-6 w-max uppercase cursor-pointer hover:bg-[#c99006] active:scale-[0.98] transition-all duration-150"
      >
        Sign Out and Continue
      </button>

      <Link
        to="/"
        className="font-termina text-white hover:font-bold underline mt-2"
      >
        Cancel
      </Link>
    </div>
  </InviteSignupShell>
);
